import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
const Hero = ({ images = [] }) => {
    const settings = {
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 2000,
    };
    return (
        <div className="object-cover w-full mt-0 sm:mt-20 p-0 sm:p-2">
            <Slider {...settings} className="overflow-hidden w-full z-25 ">
                {images.map((img, x) => (
                    <img
                        key={x}
                        src={img}
                        alt=""
                        className="object-contain rounded-md"
                    />
                ))}
            </Slider>
        </div>
    );
};

export default Hero;
